<template>
  <div class="h-100 d-flex flex-column align-center justify-space-around">
    <template v-for="(role, roleIndex) in system.roles" :key="role.id">
      <ConnectingLine
        :startElementId="`role-${system.index}-${role.id}`"
        :endElementId="`command-${system.index}-${roleIndex}`"
        :refreshKey="refreshKey"
        direction="auto"
        offsetParentId="domain-model"
      />
    </template>
    <v-card :id="`role-${system.index}-${role.id}`" class="fit-content">
      <div class="d-flex flex-column align-center">
        <v-icon class="my-2">mdi-human</v-icon>
        <bpmn-swim-lane-title
          class="px-3"
          :lane="role"
          :index="role.laneIndex"
          :svgGraph="svgGraph"
          :svgLanes="svgLanes"
          :workflow="workflow"
          disableReorder
          @name-blur="(e) => onRoleNameBlur(e, system, role.index)">
        </bpmn-swim-lane-title>
      </div>
    </v-card>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ConnectingLine from '@/components/ConnectingLine'
import BpmnSwimLaneTitle from '@/components/BpmnSwimLaneTitle'
import workflowApi from '@/api/workflowApi'
import safeStructuredClone from '@/utils/clone'

const { system, role, refreshKey } = defineProps({ system: Object, role: Object, refreshKey: Number })

const store = useStore()
const workflow = computed(() => store.state.workflow.workflow)
const svgGraph = computed(() => safeStructuredClone(store.getters['svgGraphData/svgGraphData']))
const svgLanes = computed(() => safeStructuredClone(store.getters['svgGraphData/svgLanesData']))

const onRoleNameBlur = async (event, system, roleIndex) => {
  const currentRole = system.roles[roleIndex]
  const newRoleName = event.target.innerText

  if (newRoleName === currentRole.name) {
    return
  }

  if (newRoleName === '') {
    event.target.innerText = currentRole.name
    return
  }

  let events, updateNote
  const mergeWithRole = Object.values(svgLanes.value).find(lane => lane.name === newRoleName)

  if (mergeWithRole) {
    events = system.events.filter(event => event.laneId === currentRole.id)
    events.forEach(event => {
      svgGraph.value[event.id].y = mergeWithRole.y + 30
      svgGraph.value[event.id].laneId = mergeWithRole.id
      svgGraph.value[event.id].laneIndex = mergeWithRole.index
    })
    updateNote = {
      action: 'moved events',
      target: events.map(it => it.name).join(', ')
    }
  } else {
    svgLanes.value[currentRole.id].name = newRoleName
    updateNote = {
      action: 'updated lane name',
      target: newRoleName
    }
  }

  await workflowApi.updateWorkflow({
    svgGraph: svgGraph.value,
    svgLanes: svgLanes.value,
    workflow: workflow.value,
    updateNote
  }, true)
}
</script>
